<template>
  <b-container class="bv-example-row">
    <list-table
      :url="url"
      title="لیست تراکنش های لینک پرداخت هدفدار"
      :fields="fields"
      :params="params"
      :excelroute="'excelroute'"
      :back="true"
      returnUrl="/goal-link-list"
    ></list-table>
  </b-container>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../components/table";
import persianDate from "@/helpers/persianDate";

export default {
  name: "GoalLinkTransaction",
  data() {
    return {
     
      ali:{direction:'ltr'},
      url: `goal-link/${this.$route.params.id}`,
      params: [
        {
      label: "از تاریخ",
      field: "dateFrom",
      type: "date-picker",
      },
      {
      label: "تا تاریخ",
      field: "dateTo",
      type: "date-picker",
      },
      {
      label: "کد لینک",
      field: "id",
      type: "text",
      },
      {
      label: "وبسایت",
      field: "website_name",
      type: "text",
      },
      {
      label: "شماره کارت",
      field: "card_holder_pan",
      type: "text",
      },
      {
      label: "کد رهگیری",
      field: "sale_reference_id",
      type: "text",
      },
      {
      label: "موبایل",
      field: "mobile",
      type: "text",
      },
     
      ],
      fields: [
        {
          key: "id",
          label: "کد لینک",
        },
        {
        key: "website_name",
        label: "وبسایت"
        },
        {
          key: "name",
          label: "نام پرداخت کننده",
        },
        {
          key: "cost",
          label: "مبلغ (ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "sale_reference_id",
          label: "کد رهگیری",
        },
        {
        key: "card_holder_pan",
        label: "شماره کارت",
       tdClass(value, key, item) {
            return "test";
          }
        },
        {
        key: "mobile",
        label: "موبایل"
        },
        {
          key: "created_at",
          label: "تاریخ",
        },
      ],
    };
  },
  components: {
    "list-table": TableShowData,
  },
  created() {
  },
  methods: {
  
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "تراکنش های لینک پرداخت هدفدار" }]);
  },
};
</script>
<style>
.test{
  direction: ltr;
}
</style>

